import { render, staticRenderFns } from "./CardValorMinimo.vue?vue&type=template&id=402e2cc0&scoped=true"
import script from "./CardValorMinimo.vue?vue&type=script&lang=js"
export * from "./CardValorMinimo.vue?vue&type=script&lang=js"
import style0 from "./CardValorMinimo.vue?vue&type=style&index=0&id=402e2cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e2cc0",
  null
  
)

export default component.exports